<template>
  <el-dialog title="发货确认" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
    <div class="modal-body">
      <el-form label-width="120px">
        <el-form-item label="收货人：">
          <span>{{ sendStoreOrderCartInfo.username }}</span>
        </el-form-item>
        <el-form-item label="收货电话：">
          <span>{{ sendStoreOrderCartInfo.tel }}</span>
        </el-form-item>
        <el-form-item label="收货地点：">
          <span>{{ sendStoreOrderCartInfo.address }}</span>
        </el-form-item>
        <el-form-item label="配送方式：">
          <el-select v-model="sendStoreOrderCartInfo.sendWay" style="width:100%">
            <el-option label="请选择配送方式" value=""></el-option>
            <el-option label="自送" value="SEFT"></el-option>
            <el-option label="快递" value="KUAIDI"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="sendStoreOrderCartInfo.sendWay == 'KUAIDI'" label="快递单号：">
          <el-input v-model="sendStoreOrderCartInfo.solNum" placeholder="必填，请填写快递单号"></el-input>
        </el-form-item>
        <el-form-item v-if="sendStoreOrderCartInfo.sendWay == 'KUAIDI'" label="快递公司：">
          <el-select v-model="sendStoreOrderCartInfo.solCompany" style="width:100%" placeholder="请选择快递公司">
            <el-option v-for="(item, index) in sendStoreOrderCartInfo.solCompanys" :key="index" :label="item.name"
              :value="item.statusCd">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" :rows="2" v-model="sendStoreOrderCartInfo.remark" placeholder="选填，请填写备注">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">关闭</el-button>
      <el-button type="primary" @click="_sendOrderCart">确定发货</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { sendStoreOrderCart, queryStoreOrderAddress } from '@/api/order/storeOrderCartApi'
import { getDict } from '@/api/shop/shopApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'SendStoreOrderCart',
  data() {
    return {
      dialogVisible: false,
      sendStoreOrderCartInfo: {
        orderId: '',
        username: '',
        tel: '',
        address: '',
        solCompany: '',
        solNum: '',
        remark: '',
        sendWay: 'SEFT',
        solCompanys: [],
        shopId: ''
      }
    }
  },
  methods: {
    open(order) {
      this.clearSendStoreOrderCart()
      this.sendStoreOrderCartInfo.orderId = order.orderId
      this._loadStoreOrderAddress()
      this._loadSolCompanys()
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
    },
    async _loadStoreOrderAddress() {
      const param = {
        page: 1,
        row: 1,
        orderId: this.sendStoreOrderCartInfo.orderId,
        shopId: getShopId()
      }
      try {
        const res = await queryStoreOrderAddress(param)
        Object.assign(this.sendStoreOrderCartInfo, res.data[0])
      } catch (error) {
        console.error('请求失败处理', error)
      }
    },
    async _loadSolCompanys() {
      try {
        const { data } = await getDict('store_order_logistics', 'sol_company')
        this.sendStoreOrderCartInfo.solCompanys = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    clearSendStoreOrderCart() {
      this.sendStoreOrderCartInfo = {
        orderId: '',
        username: '',
        tel: '',
        address: '',
        solCompany: '',
        solNum: '',
        remark: '',
        sendWay: 'SEFT',
        solCompanys: [],
        shopId: ''
      }
    },
    async _sendOrderCart() {
      this.sendStoreOrderCartInfo.shopId = getShopId()
      try {
        const res = await sendStoreOrderCart(this.sendStoreOrderCartInfo)
        if (res.code === 0) {
          this.$message.success('发货成功')
          this.handleClose()
          this.$emit('success')
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.error('请求失败处理', error)
      }
    }
  }
}
</script>

<style scoped>
.modal-body {
  padding: 20px;
}
</style>